import {
  MODAL_DOCS_STANDARD_BLOCKS,
  assembleModalDescription,
} from '../../../utils/spds/metadata/modal-docs';
import { Metadata } from '../../../utils/spds/metadata';
import { hash } from '@ember/helper';
import FlexColumn from '../layout/flex/column.gjs';
import StandardBody from './standard/body.gjs';
import StandardFooter from './standard/footer.gjs';
import StandardHeader from './standard/header.gjs';
import Super from '../core/modal.gjs';
import styles from './standard.module.scss';

const METADATA = Metadata.define({
  description: assembleModalDescription(
    'Basic design system modal with limited built-in configuration.',
    MODAL_DOCS_STANDARD_BLOCKS
  ),
  name: 'Standard',
  resources: {
    figma:
      'https://www.figma.com/design/g4zf0Vkj39VcCyleokv2rl/%E2%9D%96-Air-web-components?node-id=25680-18273&m=dev',
    zeroheight: 'https://www.simplepractice.design/1d0abbc0a/p/380570-modal',
  },
});

export default class SpdsModalStandard extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);

  baseClass = 'spds-modal';
  modal = true;
  styles = styles;

  get bodyId() {
    return this.composeSubcomponentId('body');
  }

  get footerId() {
    return this.composeSubcomponentId('footer');
  }

  get headerId() {
    return this.composeSubcomponentId('header');
  }

  <template>
    <FlexColumn
      @id={{this.id}}
      @tag="dialog"
      class={{this.classes}}
      data-test-spds-modal
      {{this.setupComponent}}
      ...attributes
    >
      {{yield
        (hash
          Body=(component StandardBody id=this.bodyId)
          Footer=(component StandardFooter id=this.footerId)
          Header=(component StandardHeader close=this.beforeClose id=this.headerId)
          beforeClose=this.beforeClose
          close=this.close
        )
      }}
    </FlexColumn>
  </template>
}

export const MODAL_STANDARD_METADATA = SpdsModalStandard.metadata;
